import React, { useState } from "react";
import PropTypes from "prop-types";

ColumnPicker.propTypes = { visibleCols: PropTypes.arrayOf(PropTypes.string).isRequired, onChange: PropTypes.func.isRequired };

export const ALL_COLUMNS = [
  { key: "ref_id",            label: "Ref #",         alwaysVisible: true },
  { key: "title",             label: "Title",         alwaysVisible: true },
  { key: "request_type_name", label: "Type"           },
  { key: "workflow_name",     label: "Workflow"       },
  { key: "stage_name",        label: "Stage"          },
  { key: "status",            label: "Status"         },
  { key: "assignee_name",     label: "Assignee"       },
  { key: "priority",          label: "Priority"       },
  { key: "sla",               label: "SLA"            },
  { key: "submitted_by_name", label: "Submitted By"   },
  { key: "created_at",        label: "Submitted On"   },
];

export const DEFAULT_VISIBLE = [
  "ref_id", "title", "request_type_name", "workflow_name",
  "stage_name", "status", "assignee_name", "priority", "sla",
];

export default function ColumnPicker({ visibleCols, onChange }) {
  const [open, setOpen] = useState(false);

  const toggle = (key) => {
    if (visibleCols.includes(key)) {
      if (visibleCols.length > 2) onChange(visibleCols.filter((k) => k !== key));
    } else {
      onChange([...visibleCols, key]);
    }
  };

  return (
    <div className="dropdown">
      <button
        className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
        onClick={() => setOpen((o) => !o)}
        title="Choose columns"
      >
        <i className="bi bi-layout-three-columns" />
        <span className="d-none d-md-inline">Columns</span>
      </button>
      {open && (
        <div
          className="dropdown-menu show p-2 shadow"
          style={{ minWidth: 200, right: 0, left: "auto" }}
        >
          <div className="d-flex align-items-center justify-content-between mb-2 px-1">
            <small className="fw-semibold text-muted">COLUMNS</small>
            <button className="btn-close btn-sm" onClick={() => setOpen(false)} />
          </div>
          {ALL_COLUMNS.map((col) => (
            <label key={col.key} className="dropdown-item d-flex align-items-center gap-2 py-1">
              <input
                type="checkbox"
                checked={visibleCols.includes(col.key)}
                onChange={() => toggle(col.key)}
                disabled={col.alwaysVisible}
              />
              <span>{col.label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
